module.exports = __webpack_public_path__ + "media/images/article/2021_05-a3a063412e458c22c4d5239356e3affe.png";